module.exports = fox._r("images/bg/signup_block_bg.jpg", __webpack_public_path__ + "images/bg/signup_block_bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg/signup_block_bg.jpg
// module id = 160
// module chunks = 5